import { StepInstance } from '../step-instance';
import { MultiChoiceQuestion } from './multi-choice-question';

export declare class StepExamMultiChoinceInstance extends StepInstance {
  public questions?: MultiChoiceQuestion[];
}
